export enum FileLinkedType {
  QcPdfInternal = "QcPdfInternal",
  QcPdf = "QcPdf",
  QcPdfSecondary = "QcPdfSecondary",
  QcPdfThird = "QcPdfThird",
  HDR10XmlMetadataUserUpload = "HDR10XmlMetadataUserUpload",
  HDR10XmlMetadata = "HDR10XmlMetadata",
  HDRDolbyVisionMetadataUserUpload = "HDRDolbyVisionMetadataUserUpload",
  HDRDolbyVisionMetadata = "HDRDolbyVisionMetadata",
  PosterTitleMain = "PosterTitleMain",
  QcExcel = "QcExcel",
  ProxyUploadedByUser = "ProxyUploadedByUser",
  WaveformData = "WaveformData",
  TreeGraphData = "TreeGraphData",
  KdmXmlMetadata = "KdmXmlMetadata",
  AAF = "AAF",
  Thumbnail = "Thumbnail",
  CoverTitleMain = "CoverTitleMain",
}
